module.exports = __webpack_public_path__ + "img/25.b7352f83.png";